<template>
    <QualificationField :title="$t('profile.vetting.qualification.phone.number.title')">
        <VJoyWrapper no-margin>
            <TextField :content="qualification.phoneNumber" :replace-by="$t('profile.vetting.qualification.phone.number.empty.placeholder')" />
            <VJoyIconButton
                v-if="qualification.phoneNumber"
                size="xsmall"
                icon="copy"
                variant="ghost"
                @click="clipboardCopy(qualification.phoneNumber, $t('profile.vetting.qualification.phone.number.copied'))"
            />
        </VJoyWrapper>
    </QualificationField>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {copyToClipboard} from '@malt/dom';
    import {pushVJoySnackbar, VJoyWrapper, VJoyIconButton} from '@maltjoy/core-vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();
    const {qualification} = storeToRefs(profileQualificationStore);

    function clipboardCopy(data: string, message: string) {
        copyToClipboard(data);
        pushVJoySnackbar({props: {message}});
    }
</script>
